/**
 * 异步任务并发管理，避免相同任务重复执行（api请求、sdk异步初始化），参考 go语言的 singleflight
 */
export class Singleflight {
    constructor() {
        this.lockMap = {}; // 是否锁定
        this.cbQueue = {}; // 回调队列
    }
    /**
     * 返回全局单例
     */
    static getInstance() {
        if (!Singleflight.instance) {
            Singleflight.instance = new Singleflight();
        }
        return Singleflight.instance;
    }
    /**
     * @description 执行任务，任务在锁定期间只会执行一次，每个回调都是使用第一次执行的结果
     * @param {Function} taskBuilder 任务构造函数，返回 Promise
     */
    do(key, taskBuilder) {
        return new Promise((resolve, reject) => {
            const cbQueue = this.cbQueue;
            if (!cbQueue[key]) {
                cbQueue[key] = [];
            }
            cbQueue[key].push([resolve, reject]);
            const lockMap = this.lockMap;
            if (!lockMap[key]) {
                lockMap[key] = true;
                const p = taskBuilder(key);
                p && p.then && p.then(this._resolveTask.bind(this, key), this._rejectTask.bind(this, key));
            }
        });
    }
    /**
     * 成功回调
     * @param {*} res
     */
    _resolveTask(key, res) {
        const cbQueue = this.cbQueue;
        const queue = cbQueue[key] || [];
        for (const task of queue) {
            task[0](res);
        }
        delete cbQueue[key];
        delete this.lockMap[key];
    }
    /**
     * 失败回调
     * @param {*} err
     */
    _rejectTask(key, err) {
        const cbQueue = this.cbQueue;
        const queue = cbQueue[key] || [];
        for (const task of queue) {
            task[1](err);
        }
        delete cbQueue[key];
        delete this.lockMap[key];
    }
}
Singleflight.instance = null;
